import Vue from 'vue'
import Vuex from 'vuex'
import VueSweetalert2 from 'vue-sweetalert2'
import * as actions from './actions'
import * as getters from './getters'
import lang from './modules/lang'
import delivery from './modules/delivery'
import orderFulfillment from './modules/order-fulfillment'

Vue.use(Vuex)
Vue.use(VueSweetalert2)

const debug = process.env.NODE_ENV !== 'production'

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    state[variable] = value
  }
}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    lang,
    delivery,
    orderFulfillment
  },
  strict: debug
})